export default {
  turnstile_site_key: process.env.REACT_APP_TURNSTILE_KEY,
};
